export default "__VITE_ASSET__DKfUdAp4__"